import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import Text from '../../assets/styles/Text';
import isotipo from '../../assets/images/isotipo-red.svg';
import * as styles from './styles';

export default function ChangePageAuth({ link, text }) {
  return (
    <styles.Container>
      <Link to={link}>
        <img src={isotipo} alt="isotipo" />
        <Text.P>{text}</Text.P>
      </Link>
    </styles.Container>
  );
}

ChangePageAuth.propTypes = {
  link: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
};
